function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import MuiLink from '@mui/material/Link';
import { urlStringForPathKey } from '@paddl/utils-js';
import { SocialIcons } from '../..';
import { PublicFooterMetaSocialWrapper, PublicFooterMetaSocialInnerWrapper, MenuLinks, SocialLinksWrapper, socialLinkStyles } from './PublicFooterMetaSocial.styles';
export const PublicFooterMetaSocial = () => {
  const socialLinkObjects = [_objectSpread(_objectSpread({}, socialLinkStyles.facebook), {}, {
    key: 'facebook',
    link: 'https://www.facebook.com/paddljobs/'
  }), _objectSpread(_objectSpread({}, socialLinkStyles.linkedin), {}, {
    key: 'linkedin',
    link: 'https://www.linkedin.com/company/paddl/'
  }), _objectSpread(_objectSpread({}, socialLinkStyles.twitter), {}, {
    key: 'twitter',
    link: 'https://twitter.com/PaddlJobs'
  }), _objectSpread(_objectSpread({}, socialLinkStyles.instagram), {}, {
    key: 'instagram',
    link: 'https://www.instagram.com/paddl/'
  })];
  const menuLinkObjects = [{
    link: 'http://status.paddl.com/',
    text: 'Status',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    link: 'https://about.paddl.com/terms',
    text: 'Terms',
    target: '_self'
  }, {
    link: 'https://about.paddl.com/terms#privacy',
    text: 'Privacy',
    target: '_self'
  }, {
    link: '/sitemaps',
    text: 'Sitemap',
    target: '_self'
  }];
  const socialLinks = socialLinkObjects.map(_ref => {
    let {
      key,
      link,
      colours,
      hoverColours
    } = _ref;
    return /*#__PURE__*/React.createElement(MuiLink, {
      key: key,
      href: link,
      target: "_blank",
      rel: "noopener noreferrer",
      "data-test-id": "social-links",
      underline: "none"
    }, /*#__PURE__*/React.createElement(SocialIcons, {
      type: key,
      colours: colours,
      hoverColours: hoverColours
    }));
  });
  const menuLinks = menuLinkObjects.map(_ref2 => {
    let {
      text,
      link,
      target,
      rel
    } = _ref2;
    return /*#__PURE__*/React.createElement(MuiLink, {
      key: text,
      href: urlStringForPathKey(link),
      target: target,
      rel: rel
    }, text);
  });
  return /*#__PURE__*/React.createElement(PublicFooterMetaSocialWrapper, null, /*#__PURE__*/React.createElement(PublicFooterMetaSocialInnerWrapper, null, /*#__PURE__*/React.createElement(SocialLinksWrapper, null, socialLinks), /*#__PURE__*/React.createElement(MenuLinks, {
    "data-test-id": "menu-links"
  }, menuLinks)));
};